module.exports = __webpack_public_path__ + "img/delete.75606afb.svg";